function getCartUrl() {
  console.log('[Cart] getCartUrl() called');

  if (window.routes && window.routes.cart_url) {
    console.log('[Cart] Using window.routes.cart_url:', window.routes.cart_url);
    return window.routes.cart_url;
  }

  console.log('[Cart] window.routes.cart_url not found. Using fallback: /cart');
  return '/cart';
}

  function updateHeaderCartCount(cartData) {
    const count = cartData && typeof cartData.item_count === 'number' ? cartData.item_count : 0;
    const countBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');

    if (count === 0) {
      countBubble?.remove();
      return;
    }

    if (countBubble) {
      countBubble.innerHTML =`<span aria-hidden="true">${count}</span><span class="visually-hidden">${count} items in cart</span>`;
      return;
    }

    const cartIconButton = document.getElementById('cart-icon-bubble');
    if (cartIconButton && count > 0) {
      const bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = `<span aria-hidden="true">${count}</span><span class="visually-hidden">${count} items in cart</span>`;
      cartIconButton.appendChild(bubble);
    }
  }

function replaceCartDrawer(sectionHtml) {

  const parsedDocument = new DOMParser().parseFromString(sectionHtml, 'text/html');
  const newDrawer = parsedDocument.querySelector('cart-drawer');
  const currentDrawer = document.querySelector('cart-drawer');


  if (!newDrawer || !currentDrawer) {
    console.warn('[Cart] Cannot replace drawer - missing drawer element');
    return;
  }

  const wasOpen = currentDrawer.classList.contains('active');

  currentDrawer.className = newDrawer.className;
  currentDrawer.innerHTML = newDrawer.innerHTML;


  syncCartDrawerOverlay(currentDrawer);

  if (wasOpen) {
    console.log('[Cart] Restoring drawer open state');

    currentDrawer.classList.add('active');
    document.body.classList.add('overflow-hidden');
  }

  console.log('[Cart] replaceCartDrawer() completed');
}

function syncCartDrawerOverlay(cartDrawer) {
  console.log('[Cart] syncCartDrawerOverlay() called');

  const overlay = cartDrawer && cartDrawer.querySelector('#CartDrawer-Overlay');

  console.log('[Cart] Overlay found:', !!overlay);
  console.log(
    '[Cart] cartDrawer.close available:',
    !!cartDrawer && typeof cartDrawer.close === 'function'
  );

  if (!overlay || typeof cartDrawer.close !== 'function') {
    console.warn('[Cart] Cannot sync overlay');
    return;
  }

  overlay.onclick = cartDrawer.close.bind(cartDrawer);

  console.log('[Cart] Overlay click handler attached');
}

async function refreshCartDrawer() {
  console.log('[Cart] refreshCartDrawer() called');
  console.log('[Cart] refreshInFlightMini:', refreshInFlightMini);

  if (refreshInFlightMini) {
    console.log('[Cart] Refresh already in progress. Skipping.');
    return;
  }

  refreshInFlightMini = true;

  console.log('[Cart] Refresh started');

  try {
    const cartUrl = getCartUrl();

    console.log('[Cart] Fetching cart drawer:', `${cartUrl}?section_id=cart-drawer`);
    console.log('[Cart] Fetching cart data:', '/cart.js');

    const [drawerResponse, cartResponse] = await Promise.all([
      fetch(`${cartUrl}?section_id=cart-drawer`, { cache: 'no-store' }),
      fetch('/cart.js', { cache: 'no-store' }),
    ]);

    console.log('[Cart] Drawer response:', {
      ok: drawerResponse.ok,
      status: drawerResponse.status,
      statusText: drawerResponse.statusText,
    });

    console.log('[Cart] Cart response:', {
      ok: cartResponse.ok,
      status: cartResponse.status,
      statusText: cartResponse.statusText,
    });

    if (drawerResponse.ok) {
      console.log('[Cart] Reading drawer HTML');

      const drawerHtml = await drawerResponse.text();

      console.log('[Cart] Drawer HTML received. Length:', drawerHtml.length);

      replaceCartDrawer(drawerHtml);
    } else {
      console.warn('[Cart] Drawer request failed');
    }

    if (cartResponse.ok) {
      console.log('[Cart] Reading cart JSON');

      const cartData = await cartResponse.json();

      console.log('[Cart] Cart data:', cartData);
      console.log('[Cart] Cart item count:', cartData.item_count);
      console.log('[Cart] Cart total:', cartData.total_price);

      updateHeaderCartCount(cartData);

      console.log('[Cart] Header cart count updated');
    } else {
      console.warn('[Cart] Cart JSON request failed');
    }

    const cartDrawer = document.querySelector('cart-drawer');

    console.log('[Cart] Final cart drawer found:', !!cartDrawer);

    if (cartDrawer) {
      console.log('[Cart] Final drawer active:', cartDrawer.classList.contains('active'));
      console.log('[Cart] cartDrawer.open available:', typeof cartDrawer.open === 'function');
    }

    if (
      cartDrawer &&
      !cartDrawer.classList.contains('active') &&
      typeof cartDrawer.open === 'function'
    ) {
      console.log('[Cart] Opening cart drawer');
      cartDrawer.open();
    }

    console.log('[Cart] refreshCartDrawer() completed successfully');
  } catch (error) {
    console.error('[Cart] Error refreshing cart drawer:', error);
  } finally {
    refreshInFlightMini = false;
    console.log('[Cart] Refresh lock released');
  }
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.defaultSubmitButtonText = this.submitButtonText.textContent;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        const stickySubmitButtonText = document.querySelector('#sticky-atc-wrapper .sticky-atc-button__text');
        const defaultStickySubmitButtonText = stickySubmitButtonText?.textContent;
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButtonText.textContent = window.variantStrings.addingToCart;
        this.querySelector('.loading__spinner').classList.add('hidden');
        if (stickySubmitButtonText) stickySubmitButtonText.textContent = window.variantStrings.addingToCart;

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const cartPageItems = document.querySelector('#main-cart-items');
        const cartPageSectionId = cartPageItems?.dataset?.id;

        // minicart update logic to prevent adding more items than available in inventory 
        let inventoryQty = 0, cartQty = 0, allowedQty = 0, atc_limit_enabled, atc_limit_quantity;
        const variantInput = document.querySelectorAll(".quantity__input[data-available-quantity][data-cart-quantity]");
        const cartDrawer = document.querySelector('#CartDrawer');
        atc_limit_enabled = cartDrawer ? cartDrawer.dataset.atcLimitEnabled === 'true' : false;
        atc_limit_quantity = cartDrawer ? parseInt(cartDrawer.dataset.atcLimitQuantity) : 0;

        if (variantInput.length > 0) {
          const start = Math.max(variantInput.length - 2, 0);
          for (let i = start; i < variantInput.length; i++) {
            inventoryQty = parseInt(variantInput[i].dataset.availableQuantity);
            cartQty = parseInt(variantInput[i].dataset.cartQuantity);
            break;
          }
        }
        if (atc_limit_enabled) {
          inventoryQty = Math.min(inventoryQty, atc_limit_quantity);
        }
        allowedQty = inventoryQty - cartQty;

        if (this.form) {
          const quantityInput = this.form.quantity
          if (quantityInput && quantityInput.value > allowedQty && allowedQty > 0) {
            quantityInput.value = allowedQty;
            this.handleErrorMessage(`Only ${inventoryQty} items were added to your cart due to availability.`);
          }
        }
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              if (response.status === 422) {
                refreshCartDrawer();
              }
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              if (!cartPageSectionId) return;

              fetch(`${routes.cart_url}?section_id=${cartPageSectionId}`)
                .then((sectionResponse) => sectionResponse.text())
                .then((sectionHtml) => {
                  const parsedSection = new DOMParser().parseFromString(sectionHtml, 'text/html');
                  const updatedItems = parsedSection.querySelector('#main-cart-items .js-contents');
                  const currentItems = document.querySelector('#main-cart-items .js-contents');
                  const updatedFooter = parsedSection.querySelector('#detailed-cart-footer');
                  const currentFooter = document.querySelector('#detailed-cart-footer');

                  if (updatedItems && currentItems) currentItems.innerHTML = updatedItems.innerHTML;
                  if (updatedFooter && currentFooter) currentFooter.innerHTML = updatedFooter.innerHTML;
                })
                .catch((error) => console.error('[Cart] Cart page refresh error:', error));
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
                if (document.getElementById('sticky-atc-quantity')) {
                  document.getElementById('sticky-atc-quantity').value = 1;
                }
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (!this.error) this.submitButtonText.textContent = this.defaultSubmitButtonText;
            if (!this.error && stickySubmitButtonText) {
              stickySubmitButtonText.textContent = defaultStickySubmitButtonText;
            }
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

handleErrorMessage(errorMessage = false) {
  if (this.hideErrors) return;

  this.errorMessageWrapper =
    this.errorMessageWrapper ||
    this.querySelector('.product-form__error-message-wrapper');

  if (!this.errorMessageWrapper) return;

  this.errorMessage =
    this.errorMessage ||
    this.errorMessageWrapper.querySelector('.product-form__error-message');

  // Clear previous hide timer
  clearTimeout(this.errorMessageHideTimer);

  if (errorMessage) {
    // Show the error again
    this.errorMessageWrapper.style.display = 'block';
    this.errorMessageWrapper.toggleAttribute('hidden', false);

    this.errorMessage.textContent = errorMessage;

    this.errorMessageWrapper.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

    // Hide after 6 seconds
    this.errorMessageHideTimer = setTimeout(() => {
      this.errorMessageWrapper.style.display = 'none';
    }, 6000);
  } else {
    this.errorMessageWrapper.toggleAttribute('hidden', true);
    this.errorMessageWrapper.style.display = 'none';
  }
}

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
